import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useUser } from "@/hooks/useUser";
import { PlusIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import { SpecialEntity } from "@/lib/types";
import { apiEndpointBuilder } from "../permission/PermissionChecker2";

interface NavQuickAction {
  name: string;
  onClick: () => void;
  needEntity: SpecialEntity[];
}

export function NavQuickActions() {
  const { t } = useTranslation();
  const { user, isLoading } = useUser();
  const {
    goToTemplateAdd,
    goToTemplateStockAdd,
    goToContent,
    goToContentGroupAdd,
    goToChannelAdd,
    goToCampaignAdd,
    goToPlayerAdd,
  } = useAppNavigate();

  if (isLoading) return null;

  // @ts-ignore
  const allMenuOptions: NavQuickAction[] = [
    {
      name: t("entities.template"),
      onClick: goToTemplateAdd,
      needEntity: ["DsTemplate"],
    },
    {
      name: t("entities.templateStock"),
      onClick: goToTemplateStockAdd,
      needEntity: ["DsStockTemplate"],
    },
    {
      name: t("entities.content"),
      onClick: () => goToContent(true),
      needEntity: ["Content"],
    },
    {
      name: t("entities.contentGroup"),
      onClick: goToContentGroupAdd,
      needEntity: ["ContentGroup"],
    },
    {
      name: t("entities.channel"),
      onClick: goToChannelAdd,
      needEntity: [],
    },
    {
      name: t("entities.campaign"),
      onClick: goToCampaignAdd,
      needEntity: [],
    },
    {
      name: t("entities.player"),
      onClick: goToPlayerAdd,
      needEntity: ["Player"],
    },
  ].filter((option) =>
    option.needEntity.some((entityString) =>
      user?.apiRights.some(
        (apiRight) => apiRight.apiEndPoint === apiEndpointBuilder(entityString as SpecialEntity, "Add")
      )
    )
  );

  if (!allMenuOptions.length) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Button size="sm" variant="outline">
          <PlusIcon className="w-4 h-4" /> {t("common.new")}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {allMenuOptions.map((option) => (
          <DropdownMenuItem key={option.name} onClick={option.onClick}>
            {option.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
